export enum TabSettingsName {
  TARIFF_OPTIONS = 'tariff-options',
  APPS = 'apps',
  BILLS = 'bills',
  ADDONS = 'addons',
  TOP_UP = 'top-up',
  NUMBERS = 'numbers',
  ADDITIONAL_SERVICES = 'additional-services',
}
